import "./tests.css";

const TestCard = ({title, desc, tag}) => (
  <div className="test-card">
    <h4>{title}</h4>
    <p>{desc}</p>
  </div>
);

export default function TestsGrid(){
  const tests = [
    {title:"Technical Inspection", desc:"Qualification Round"},
    {title:"Brake Test", desc:"Qualification Round"},
    {title:"Noise Test[CV ONLY]", desc:"Qualification Round"},
    {title:"Virtual Round", desc:"100 Points"},
    {title:"Weigth Test", desc:"50 Points"},
    {title:"Engineering Design Round", desc:"150 Points"},
     {title:"Marketing And Businness Plan", desc:"100 Points"},
    {title:"Cost And Manufacturing Plan", desc:"100 Points"},
    {title:"Innovation Round", desc:"100 Points"},
    {title:"Acceleration Test", desc:"100 Points"},
    {title:"Maneuverability Round", desc:"100 Points"},
    {title:"Traction War", desc:"Optional"},
    {title:"Time Trail", desc:"For Line up of Karts"},
    {title:"Endurance", desc:"200 Points"},
    {title:"Efficiency Test", desc:"100 Points"},
  ];


  return (
    <section className="tests container1" id="tests">
      <h2 className="section-title">Championship Tests</h2>
      <p className="lead">"The program incorporates a series of assessments intended to evaluate every dimension of performance."</p>

      <div className="tests-grid">
        {tests.map((t,i) => <TestCard key={i} {...t} />)}
      </div>
    </section>
  );
}
